import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import { getHostPackageStateApi, getIsPackageInstalled } from "../../externalApi/PackageStateApi";
export class PackageStateApi {
    constructor() {
        this._packageStateApi = null;
        this._eventListeners = new Array();
    }
    async initialize() {
        if (!this._packageStateApi) {
            this._packageStateApi = await getHostPackageStateApi();
            if (!this._packageStateApi) {
                // Api not available when running outside the host
                Trace.logEvent(dashboard, "PackageStateAPIUnavailable", 1 /* information */);
            }
            else {
                await this._packageStateApi.addEventListener("packagestateupdated", async () => {
                    this._isPackageInstalled = await getIsPackageInstalled("Microsoft.MicrosoftEdge.Stable_8wekyb3d8bbwe");
                    this.fireEvent("packagestateupdated");
                });
            }
        }
    }
    async isPackageInstalled(pfn) {
        if (this._isPackageInstalled == undefined) {
            this._isPackageInstalled = await getIsPackageInstalled(pfn);
        }
        return this._isPackageInstalled;
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    fireEvent(eventName) {
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index](eventName);
            }
        }
    }
    firePackageStateUpdatedEvent() {
        this.fireEvent("packagestateupdated");
    }
}
